import type { LoaderArgs } from '@remix-run/server-runtime';

export const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};

export const scrollIntoView = (element: HTMLElement | null) => {
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
};

export const getUrlSearchParams = (request?: LoaderArgs['request']) => {
  if (request) {
    const url = new URL(request.url);
    return url.searchParams;
  }
  if (isBrowser()) {
    return new URLSearchParams(window.location.search);
  }
  return new URLSearchParams();
};

/** Nếu sử dụng useSearchParams => Loader sẽ được chạy lại => Thừa request */
export const updateURLSearchParamsOfBrowserWithoutNavigation = (searchParams: string) => {
  const newUrl = [window.location.pathname, searchParams].filter(Boolean).join('');
  window.history.replaceState(null, '', newUrl);
};
